import { useMemo } from 'react'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL, OFFER_TYPE_VILLA } from 'constants/offer'
import { mergeOccupants } from 'lib/search/searchUtils'
import useOfferList from 'hooks/Offers/useOfferList'

export function useHomesVillasOnSearch(listFilters: App.OfferListFilters) {
  const homesVillasEnabled =
    !!listFilters.destinationId &&
    !listFilters.holidayTypes?.includes('Homes & Villas')

  const homesVillasFilters: App.OfferListFilters = useMemo(() => {
    const offerTypes: App.OfferListOfferType[] = [OFFER_TYPE_VILLA, OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON]
    const rooms = (listFilters.rooms && listFilters.rooms.length > 1) ?
        [mergeOccupants(listFilters.rooms)] : listFilters.rooms
    return {
      destinationId: listFilters.destinationId,
      checkIn: listFilters.checkIn,
      checkOut: listFilters.checkOut,
      flexibleMonths: listFilters.flexibleMonths,
      flexibleNights: listFilters.flexibleNights,
      rooms,
      offerTypes,
      holidayTypes: ['Homes & Villas'],
      holidayTypesScoped: ['Homes & Villas'],
      limit: 15,
    }
  }, [listFilters])

  const homesVillasOfferList = useOfferList(homesVillasFilters, { disabled: !homesVillasEnabled })

  return {
    enabled: homesVillasEnabled,
    filters: homesVillasFilters,
    offerList: homesVillasOfferList,
  }
}
